import type { EntryValueViewT } from "@patient-watch/types";
import { sortEntryValuesView } from "../entries/services/sortEntryValuesView";

export interface EntryValuePageGroup {
    pageIndex: number | null;
    pageLabel: string | undefined;
    values: EntryValueViewT[];
}

export function groupEntryValuesByPage(otherValues: EntryValueViewT[]): EntryValuePageGroup[] {
    return Array.from(new Set(otherValues.map((ev) => ev.page_index)))
        .sort((a, b) => (a ?? 0) - (b ?? 0))
        .map((pageIndex) => {
            const pageValues = sortEntryValuesView(otherValues.filter((ev) => ev.page_index === pageIndex));
            return pageValues.length > 0
                ? {
                      pageIndex,
                      pageLabel: pageValues[0]?.page_label,
                      values: pageValues,
                  }
                : null;
        })
        .filter((group): group is EntryValuePageGroup => group !== null);
}

/** Show page headings whenever answers span more than one page, or a page has several questions. */
export function shouldShowPageHeadings(groups: EntryValuePageGroup[]): boolean {
    return (
        groups.filter((group) => group.pageIndex != null).length > 1 || groups.some((group) => group.values.length > 1)
    );
}
